/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodMouseActionsEnum {
    HOVER = 'HOVER',
    CLICK = 'CLICK',
}
